import React, { Fragment } from "react";

import { DeviceDropdownMenu } from "../../../../../../../components/devices/DeviceDropdownMenu";
import {
  MoveDeviceDropdownItem,
  MoveDeviceModalItem,
} from "../../../../../../../components/devices/moveDeviceItem";
import {
  RemoveDeviceDropdownItem,
  RemoveDeviceModalItem,
} from "../../../../../../../components/devices/removeDeviceItem";
import {
  UnmergeDeviceDropdownItem,
  UnmergeDeviceModalItem,
} from "../../../../../../../components/devices/unmergeDeviceItem";
import {
  RenameDeviceDropdownItem,
  RenameDeviceModalItem,
} from "../../../../../../../components/devices/renameDeviceItem";
import {
  MergeDeviceDropdownItem,
  MergeDeviceModalItem,
} from "../../../../../../../components/devices/mergeDeviceItem";
import { Mobile, NotMobile } from "../../../../../../../hocs/Responsive";
import { DeviceActionsToggle } from "../../../../../../../components/devices/DeviceActionsDialog";

export const ProfileDevicesDropdownActions = ({
  identifiers,
  deviceDetails,
  name,
  profile,
}) => {
  // temporary fix for the case when backend doesn't return device details
  const identifierInfo = deviceDetails[identifiers[0]];
  const deviceType = identifierInfo && identifierInfo.type;
  const isMergeAvailable = identifiers.length < 2;
  const isUnmergeAvailable = identifiers.length > 1;
  const { logicalDeviceId } = identifierInfo;

  const dropdownItems = [
    isMergeAvailable && (
      <MergeDeviceDropdownItem
        deviceToMerge={{
          identifiers,
          type: deviceType,
          logicalDeviceId,
        }}
      />
    ),
    <RenameDeviceDropdownItem
      device={{ identifiers, name, profile, logicalDeviceId }}
    />,
    <MoveDeviceDropdownItem
      deviceName={name}
      logicalDeviceId={logicalDeviceId}
    />,
    <RemoveDeviceDropdownItem
      deviceName={name}
      logicalDeviceId={logicalDeviceId}
    />,
    isUnmergeAvailable && (
      <UnmergeDeviceDropdownItem
        device={{ identifiers, name, profile, logicalDeviceId }}
      />
    ),
  ].filter(Boolean);

  const modalItems = [
    isMergeAvailable && (
      <MergeDeviceModalItem
        deviceToMerge={{
          identifiers,
          type: deviceType,
          logicalDeviceId,
        }}
      />
    ),
    <RenameDeviceModalItem
      device={{ identifiers, name, profile, logicalDeviceId }}
    />,
    <MoveDeviceModalItem deviceName={name} logicalDeviceId={logicalDeviceId} />,
    <RemoveDeviceModalItem
      deviceName={name}
      logicalDeviceId={logicalDeviceId}
    />,
    isUnmergeAvailable && (
      <UnmergeDeviceModalItem
        device={{ identifiers, name, profile, logicalDeviceId }}
      />
    ),
  ].filter(Boolean);

  return (
    <Fragment>
      <Mobile>
        <DeviceActionsToggle
          deviceName={name}
          menuItems={modalItems}
          ariaDeviceName={name}
        />
      </Mobile>
      <NotMobile>
        <DeviceDropdownMenu menuItems={dropdownItems} deviceName={name} />
      </NotMobile>
    </Fragment>
  );
};
